export default __webpack_public_path__ + "static/media/formentera.2240fa14.jpg";